import React from 'react';

import { FreeTrialSidebarWidget, useSidebarWidgetHeight } from '../../features/FreeTrial';
import LinksMenu from './LinksMenu';

type SidebarProps = {
  isCollapsed: boolean;
};

function Sidebar({ isCollapsed }: SidebarProps) {
  const height = useSidebarWidgetHeight();

  return (
    <>
      <div style={{ paddingBottom: isCollapsed ? 0 : height }}>
        <LinksMenu isCollapsed={isCollapsed} />
      </div>
      <FreeTrialSidebarWidget isCollapsed={isCollapsed} height={height} />
    </>
  );
}

export default Sidebar;
